import { Accordion, AccordionDetails, AccordionSummary, Grid2 } from "@mui/material";
import { ArrowDownward } from "@mui/icons-material";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialSelect from "../../../../components/MasterSelect";

const FieldClassificationAccordion = ({
  expanded,
  onAccordionChange,
  formData,
  handleChange,
  pageMode,
  accordionSx,
  descriptionSx,
  generalProductOptions,
  dataTypeOptions,
  fieldCategoryOptions
}) => {
  return (
    <Accordion
      expanded={expanded}
      onChange={(_, isExpanded) => onAccordionChange(isExpanded ? "fieldClassification" : false)}
      sx={accordionSx}
    >
      <AccordionSummary expandIcon={<ArrowDownward />}>
        <Grid2 container>
          <Grid2 size={{sm: 6, xs: 12 }}>
            <MaterialTypography
              component="span"
              variant="body2"
              fontWeight="bold"
            >
              Field Classification
            </MaterialTypography>
            <MaterialTypography
              component="div"
              variant="caption"
              sx={descriptionSx}
            >
              Map this field to its category, data type, and product context.
            </MaterialTypography>
          </Grid2>
        </Grid2>
      </AccordionSummary>

      <AccordionDetails>
        <Grid2 container spacing={1}>
            {/* dataTypeId */}
            <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                <MaterialTypography component="label" variant="caption" fontWeight="bold">
                Data Type*
                </MaterialTypography>
                <MaterialSelect
                name="dataTypeId"
                value={formData.dataTypeId}
                onChange={handleChange}
                options={dataTypeOptions}
                success={formData.dataTypeIdStatus === "success"}
                error={formData.dataTypeIdStatus === "error"}
                isDisabled={pageMode === "view"}
                menuPlacement="top"
                />
            </Grid2> 
            {/* fieldCategoryId */}
            <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                <MaterialTypography component="label" variant="caption" fontWeight="bold">
                Field Category*
                </MaterialTypography>
                <MaterialSelect
                name="fieldCategoryId"
                value={formData.fieldCategoryId}
                onChange={handleChange}
                options={fieldCategoryOptions}
                success={formData.fieldCategoryIdStatus === "success"}
                error={formData.fieldCategoryIdStatus === "error"}
                isDisabled={pageMode === "view"}
                menuPlacement="top"
                />
            </Grid2>         
            {/* gProductId */}
            <Grid2 size={{lg:6, md:6, sm: 12, xs: 12 }}>
                <MaterialTypography component="label" variant="caption" fontWeight="bold">
                General Product*
                </MaterialTypography>
                <MaterialSelect
                name="gProductId"
                value={formData.gProductId}
                onChange={handleChange}
                options={generalProductOptions}
                success={formData.gProductIdStatus === "success"}
                error={formData.gProductIdStatus === "error"}
                isDisabled={pageMode === "view"}
                menuPlacement="top"
                />
            </Grid2> 
        </Grid2>
      </AccordionDetails>
    </Accordion>
  );
};

export default FieldClassificationAccordion;
